import { css, cx, useTheme } from '@fable/theme'
import { FlowerFace } from './face'
import { FLOWER_PETAL_PATHS } from './utils'
import { FlowerSleepyZ } from './FlowerSleepyZ'
import {
  FlowerColors,
  FlowerFaceType,
  FlowerHeadType,
} from '../../../lib/types'
import { useStatsTheme } from '../../../theme/ctx'

interface Props {
  className?: string
  type: FlowerHeadType
  face?: FlowerFaceType
  colors: FlowerColors
}

export const FlowerHead = ({
  className = '',
  type,
  face = 'happy',
  colors,
}: Props) => {
  const { colors: themeColors } = useTheme()
  const theme = useStatsTheme((s) => s.theme)
  const faceColor = '#f9c726'
  const isHappy = face === 'happy'

  const paths = FLOWER_PETAL_PATHS[type]

  return (
    <div
      className={cx(
        'anim__flower-head',
        css`
          position: absolute;
          max-width: 110px;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          transform-origin: 50% 50%;
          z-index: 5;
          will-change: transform;
        `,
        className
      )}
    >
      <svg
        className={css`
          width: 100%;
          overflow: visible;
        `}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 110 110"
      >
        {paths.map((path, i) => (
          <path
            className={cx(
              'anim__flower-petal',
              css`
                will-change: fill;
              `
            )}
            key={i}
            d={path}
            fill={
              theme.id.includes('dark')
                ? theme.colors.goals.petalEmpty
                : colors?.empty
            }
          />
        ))}
        <path
          d="m49.85,85.97c-17.06-2.82-28.59-18.98-25.75-36.08,2.84-17.1,18.98-28.68,36.05-25.86,17.06,2.82,28.59,18.98,25.75,36.09-2.84,17.1-18.98,28.68-36.05,25.86Z"
          fill={faceColor}
        />
      </svg>
      <div
        className={css`
          width: 32%;
          position: absolute;
          top: ${isHappy ? '45%' : '50%'};
          left: 55%;
          transform: translate(-50%, -50%);
        `}
      >
        <FlowerFace type={face} color={colors?.filled} />
        {isHappy
          ? null
          : Array.from({ length: 3 }).map((_, i) => (
              <FlowerSleepyZ key={i} color={themeColors.uiGraphite} />
            ))}
      </div>
    </div>
  )
}

export const FlowerHeadPath = ({ id }: { id: string }) => (
  <svg
    className={css`
      opacity: 0;
      position: absolute;
      top: 40%;
      left: 50%;
      width: 20%;
      transform: translateX(-50%);
    `}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1373.41 272.09"
    fill="none"
    preserveAspectRatio="none"
  >
    <path
      id={`flowerHeadPath-${id}`}
      stroke="black"
      strokeWidth={4}
      d="m.34,271.73C53.03,222.38,301.32.5,686.71.5c385.38,0,633.67,221.88,686.36,271.23"
    />
  </svg>
)
